import { render, staticRenderFns } from "./SharedAccountsTable.vue?vue&type=template&id=778cbc54&scoped=true&"
import script from "./SharedAccountsTable.vue?vue&type=script&lang=js&"
export * from "./SharedAccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./SharedAccountsTable.vue?vue&type=style&index=0&id=778cbc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778cbc54",
  null
  
)

export default component.exports